import React from 'react';
import {
  Autocomplete,
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
} from '@mui/material';
import { useIsMobile } from '../hooks/use-is-mobile';

export function UserFilterAutocomplete({
  users,
  isLoadingUsers,
  onChange,
  sx,
  label = 'User Name',
  id = 'users-list',
}) {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ width: isMobile ? '100%' : 300, ...sx }}>
      <Autocomplete
        options={users}
        getOptionLabel={(option) => `${option.userName}`}
        noOptionsText={isLoadingUsers ? 'Loading...' : 'No items'}
        includeInputInList
        filterSelectedOptions
        onChange={(event, newValue) => {
          onChange(newValue?.id || 0);
        }}
        id={id}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;

          return (
            <li key={key || `${option.userName}-${option.phoneNumber}`} {...optionProps}>
              <List sx={{ width: '100%' }}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar alt="Profile" src={option.profileImage} />
                  </ListItemAvatar>
                  <ListItemText primary={option.userName} />
                </ListItem>
              </List>
            </li>
          );
        }}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </Box>
  );
}
